import stateExtender from '@/store/utils/stateExtender';
import RepositoryFactory from '@/services/repository-factory';
import datatableModule from '@/store/builder/datatableModule';
import table from '@/components/builders/configs/tables/comboOrdersTable';
import filters from '@/components/builders/configs/filters/comboOrdersFilters';
import getters from './getters';
import state from './state';
import actions from './actions';
import mutations from './mutations';

const comboOrdersRepository = RepositoryFactory.get('comboOrders');

export default stateExtender({
  namespaced: true,
  state,
  modules: {
    table: datatableModule({
      fetch: comboOrdersRepository.table,
      headers: table.headers.filter((header) => header.isShown),
      allHeaders: table.headers,
      options: {
        sortBy: ['id'],
        sortDesc: [true],
        itemsPerPage: 30,
      },
      search: filters,
    }),
  },
  getters,
  mutations,
  actions,
});
